module.exports = __webpack_public_path__ + "static/media/attach.396b6fca.svg";